import { apiClient } from './client';
import type { ApiResponse, AppNotification } from '@/types';

interface PaginatedNotifications {
  success: boolean;
  data: AppNotification[];
  pagination: { page: number; limit: number; total: number; totalPages: number };
}

export async function getNotifications(page = 1, limit = 20): Promise<PaginatedNotifications> {
  const response = await apiClient.get<PaginatedNotifications>('/notifications', {
    params: { page, limit },
  });
  return response.data;
}

export async function getUnreadCount(): Promise<number> {
  const response = await apiClient.get<ApiResponse<{ count: number }>>('/notifications/unread-count');
  return response.data.data?.count ?? 0;
}

export async function markNotificationRead(id: string): Promise<ApiResponse<void>> {
  const response = await apiClient.patch<ApiResponse<void>>(`/notifications/${id}/read`);
  return response.data;
}

export async function markAllNotificationsRead(): Promise<ApiResponse<{ count: number }>> {
  const response = await apiClient.patch<ApiResponse<{ count: number }>>('/notifications/read-all');
  return response.data;
}

export async function deleteNotification(id: string): Promise<ApiResponse<void>> {
  const response = await apiClient.delete<ApiResponse<void>>(`/notifications/${id}`);
  return response.data;
}
